// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../index';

import { gql } from 'graphql-tag';
import { PageFragmentDoc } from './page.fragment.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const PageByPathDocument = gql`
    query pageByPath($path: String!, $locale: Locale!, $currency: CurrencyInput!, $region: RegionCode!) {
  pageByPath(path: $path, locale: $locale) {
    ...page
  }
}
    ${PageFragmentDoc}`;

export function usePageByPathQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.PageByPathQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.PageByPathQuery, SchemaTypes.PageByPathQueryVariables | undefined>({ query: PageByPathDocument, variables: undefined, ...options });
};